import { render, staticRenderFns } from "./DataCardList.vue?vue&type=template&id=3dbd79af"
import script from "./DataCardList.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCardList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataCardList.vue?vue&type=style&index=0&id=3dbd79af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports